import React, { useState } from "react";
import NavBar from "../components/NavBar";
import { useNavigate, useParams } from "react-router-dom";
import Interview from "./Interview";
import Contact from "./Contact";
import PreQualify from "./PreQualify";
import Matches from "./Matches";
import ConsultantsNotes from "./ConsultantsNotes";
import Hobbies from "./Hobbies";
import HoldPeriod from "./HoldPeriod";
import Subscription from "./Subscription";
import Coaching from "./Coaching";

import './TabComponent.css';  // Create this new CSS file

const TabsComponent = () => {
  // Define the active tab state
  const [activeTab, setActiveTab] = useState("interview");
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1);
  };

  // Define a function to switch tabs
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  const { id, name } = useParams(); // from url path /interview/:id/:name

  return (
    <div>
      <NavBar />

      {/* Tab Navigation */}
      <div className="tab-container">
        <h2 className="heading tab-heading">
          {name}
        </h2>
        <div className="tab-buttons">
          <button
            className={`tab-button ${activeTab === "interview" ? "active" : ""}`}
            onClick={() => handleTabClick("interview")}
          >
            Interview
          </button>
          <button
            className={`tab-button ${activeTab === "contact" ? "active" : ""}`}
            onClick={() => handleTabClick("contact")}
          >
            Contact
          </button>
          <button
            className={`tab-button ${activeTab === "prequalify" ? "active" : ""}`}
            onClick={() => handleTabClick("prequalify")}
          >
            Pre Qualify
          </button>
          <button
            className={`tab-button ${activeTab === "matches" ? "active" : ""}`}
            onClick={() => handleTabClick("matches")}
          >
            Matches
          </button>
          <button
            className={`tab-button ${activeTab === "consultantsnotes" ? "active" : ""}`}
            onClick={() => handleTabClick("consultantsnotes")}
          >
            Consultant's notes
          </button>
          <button
            className={`tab-button ${activeTab === "holdperiod" ? "active" : ""}`}
            onClick={() => handleTabClick("holdperiod")}
          >
            Hold Period
          </button>
          <button
            className={`tab-button ${activeTab === "coaching" ? "active" : ""}`}
            onClick={() => handleTabClick("coaching")}
          >
            Coaching
          </button>
          <button
            className={`tab-button ${activeTab === "special" ? "active" : ""}`}
            onClick={() => handleTabClick("special")}
          >
            Special
          </button>
          <button
            className={`tab-button ${activeTab === "subscriptions" ? "active" : ""}`}
            onClick={() => handleTabClick("subscriptions")}
          >
            Subscriptions
          </button>
          <button
            className={`tab-button ${activeTab === "hobbies" ? "active" : ""}`}
            onClick={() => handleTabClick("hobbies")}
          >
            Hobbies
          </button>
          <button className="back-button" onClick={handleBack}>
            Back
          </button>
        </div>
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === "interview" && <Interview />}
        {activeTab === "contact" && <Contact />}
        {activeTab === "prequalify" && (
          <PreQualify />
        )}
        {activeTab === "matches" && <Matches />}
        {activeTab === "consultantsnotes" && <ConsultantsNotes />}
        {activeTab === "holdperiod" && <HoldPeriod />}
        {activeTab === "coaching" && <Coaching />}
        {activeTab === "special" && <div>Special Content coming soon</div>}
        {activeTab === "subscriptions" && (
          <Subscription />
        )}
        {activeTab === "hobbies" && <Hobbies />}
        {/* Add more content for other tabs */}
      </div>
    </div>
  );
};

export default TabsComponent;
